// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import 'element-ui/lib/theme-chalk/index.css'
import store from './vuex/store.js'

//解决路由重复点击报错
import Router from 'vue-router'

// 解决重复点击导航路由报错
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
import hls from 'videojs-contrib-hls'
Vue.use(hls)

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

// 引入video.js
import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Videojs

//swp
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)


// input自动聚焦
import focus from "@/directives/focus"
Vue.prototype.$focus = focus

//全局导入，在main.js中导入（可选） 复制功能
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

//自适应处理
import 'lib-flexible'

//图标字体
import './assets/iconfont/menuIcon/iconfont.css'
import './assets/iconfont/contentIcon/iconfont.css'

Vue.use(ElementUI)
Vue.prototype.$axios = axios
// axios.defaults.headers.post['Content-Type'] ='application/json;charset=UTF-8'
// 设置url的请求根路径
axios.defaults.baseURL = '/api/v1'
//拦截请求，如果有token值，才能继续发起请求获取数据
axios.interceptors.request.use(config => {
  // console.log(config)
  //给后端添加一个Authorization，用来判断是否当前token值   如果不存在这个值，服务器无法请求下一次响应
  config.headers.Authorization = window.sessionStorage.getItem('token')
  if (config.url.search('/api') > -1) {
    config.baseURL = '/'
  }
  return config
})
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

//注册全局的过滤器
Vue.filter('dateFormat', function (originVal) {
  const dt = new Date(originVal)

  const y = dt.getFullYear()
  //padStart(2,0)   第一个参数是一共几个字符，第二个是补全字符    字符串补全功能  头部补全
  //padEnd     尾部补全
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')
  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js